import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'empty', })
export class EmptyPipe implements PipeTransform {
  transform(value: any[], flag) {
    if (flag) {
      flag['empty'] = (!value || !value.length)
    } else if (value) {
      value['empty'] = !value.length
    }
    return value
  }
}
